import type { FC } from 'react';
import type { CategorySection } from '../../../@types/gql/home';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import CategoryCard from './card';

const HomeCategoriesSection: FC<CategorySection> = ({
  // Description,
  Title,
  Categories,
}) => {
  return (
    <section className="py-14" id='optionCategory' style={{ backgroundColor: '#f7f7f7' }}>
      <div className="container px-6 mx-auto">
        <OpacitySlideIn slideFrom={{ x: 0, y: 10 }}>
          <h2 className="text-4xl font-bold text-center whitespace-pre-wrap max-lg:text-2xl">
            {Title}
          </h2>
          {/* <p className="text-center max-w-3xl mx-auto mt-6 font-light text-gray-500">
            {Description}
          </p> */}
        </OpacitySlideIn>

        <div className="mt-8 flex max-xl:flex-wrap gap-4 justify-center">
          {Categories?.map((category, idx) => (
            <OpacitySlideIn
              className="xl:w-48 max-xl:w-44 w-full cateContainer"
              delay={idx * 0.05 + 0.1}
              key={category.id}
              slideFrom={{ x: 0, y: 10 }}
            >
              <CategoryCard {...category} />
            </OpacitySlideIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCategoriesSection;
